import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AtbHomeService } from "../../../services/atbHome.service";
import { NgForm } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import swal2 from "sweetalert2";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Subscription } from "rxjs";
import { defineLocale } from "ngx-bootstrap/chronos";
import { itLocale } from "ngx-bootstrap/locale";
import { DatePipe } from '@angular/common';
import { environment } from '../../../../environments/environment';
defineLocale("it", itLocale);
import * as moment from 'moment';

declare var jQuery: any;

export enum VoucherAgentType {
  ATB = "ATB",
  LOCATELLI = "LOCATELLI",
  TBSO = "TBSO",
  SABATB = "SABATB",
  SABATBAGI = "SABATBAGI"
}

export class VoucherAgent {
  static readonly ATB = new VoucherAgent(VoucherAgentType.ATB, "ATB");
  static readonly LOCATELLI = new VoucherAgent(VoucherAgentType.LOCATELLI, "Locatelli");
  static readonly TBSO = new VoucherAgent(VoucherAgentType.TBSO, "TBSO");
  static readonly SABATB = new VoucherAgent(VoucherAgentType.SABATB, "Arriva SAB");
  static readonly SABATBAGI = new VoucherAgent(VoucherAgentType.SABATB, "Arriva SAB - AGI");

  private constructor(private readonly type: string, public readonly name: string) {
  }

  static valueOf(type: string): VoucherAgent {
    switch (type) {
      case VoucherAgentType.ATB:
        return VoucherAgent.ATB;
      case VoucherAgentType.LOCATELLI:
        return VoucherAgent.LOCATELLI;
      case VoucherAgentType.TBSO:
        return VoucherAgent.TBSO;
      case VoucherAgentType.SABATB:
        return VoucherAgent.SABATB;
      case VoucherAgentType.SABATBAGI:
        return VoucherAgent.SABATBAGI;
    }
    return null
  }
};

@Component({
  selector: "app-voucher-redeem",
  templateUrl: "./voucher-redeem.component.html",
  styleUrls: ["../../../app.component.css"]
})
export class VoucherRedeemComponent implements OnInit {

  voucherPath;
  agentsPath;
  redeemsPath;
  redeemsCheckPath;
  transactionsPath;

  checkFirstPage;
  private sub: any;

  agents: any[] = new Array();
  vouchers: any[] = new Array();
  redeemData = {
    operatore: '',
    numeroTessera: '',
    numeroVoucher: ''
  };
  errorMessage;
  voucher: any;

  @ViewChild("redeemForm") redeemForm: NgForm;

  transactions: any[] = new Array();
  modalRef: BsModalRef;

  constructor(
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private atbService: AtbHomeService,
    private datePipe: DatePipe
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {

      if ( params['token'] == undefined  ||  params['token'] == null ||  params['token'] == "" ) {
        this.checkFirstPage = false
      } else{
        this.checkFirstPage = true
      }
    });


    if (this.checkFirstPage == true)  {

      this.sub = this.route.params.subscribe(params => {
        var token  = params['token'];
        var user = params['user'];
        var language = params['language'];
        var role = params['role'];

        localStorage.setItem("token", token);
        localStorage.setItem("user", user)
        localStorage.setItem("language", language)
        localStorage.setItem("role", role)
        this.router.navigate(['/voucher/redeem'])
      });

    }

    this.voucherPath = 'voucher'
    this.agentsPath = 'operatori'
    this.redeemsPath = 'riscatti'
    this.redeemsCheckPath = 'riscatti/verifica'
    this.transactionsPath = 'transazioni'
    this.getVoucherAgents();
    this.getVoucherRedeemed();
  }

  getVoucherAgents() {
    this.atbService.getListFilter(this.voucherPath + '/' + this.agentsPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.agents = response.results
        }
      },
      (error) => {
        console.log('Error ', error);
      }
    );
  }

  getVoucherAgentName(voucherAgentType) {
    const voucherAgent = VoucherAgent.valueOf(voucherAgentType);
    return voucherAgent ? voucherAgent.name : voucherAgentType;
  }

  getVoucherRedeemed() {
    this.spinner.show();

    this.atbService.getListFilter(this.voucherPath + '/' + this.redeemsPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.vouchers = response.results
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.spinner.hide()
      }
    );
  }

  verifyRedeemVoucher() {
    this.spinner.show();
    let showError = true;
    this.atbService.newObject(this.redeemData, this.voucherPath + '/' + this.redeemsCheckPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.voucher = response.result
          swal2({
            titleText: 'Attenzione',
            text: 'La conversione del voucher in credito a scalare comporta l’utilizzo dello stesso, fino ad esaurimento ed ' +
              'entro la scadenza indicata sul voucher, solo per l’acquisto di documenti di viaggio attraverso l’App ATB Mobile',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Converti',
            cancelButtonText: 'Annulla',
            focusCancel: true
          }).then(result => {
            if (result.value) {
              this.redeemVoucher();
            }
          });
        } else {
          switch (response.outcome.code) {
            case '0001':
              this.errorMessage = 'Tessera e/o operatore errati. Verificare i dati inseriti';
              break;
            case '0002':
              this.errorMessage = 'Questo voucher non esiste. Verificare i dati inseriti';
              break;
            case '0028':
              this.errorMessage = 'Questo voucher è già stato convertito';
              break;
            case '0029':
              this.errorMessage = 'Questo voucher risulta non ancora richiesto';
              break;
            case '0030':
              this.errorMessage = 'Questo voucher risulta già usato';
              break;
            default:
              this.errorMessage = 'Qualcosa è andato storto';
              break;
          }
          if (showError) {
            swal2('Attenzione', this.errorMessage, 'warning');
          }
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
        swal2('Attenzione', this.errorMessage, 'warning');
        this.spinner.hide()
      }
    );
  }

  resetRedeem() {
    this.redeemForm.reset({
      operatore: '',
      numeroTessera: '',
      numeroVoucher: ''
    });
  }

  redeemVoucher() {
    this.spinner.show();
    let showError = true;
    this.atbService.newObject(this.redeemData, this.voucherPath + '/' + this.redeemsPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.voucher = response.result
          this.resetRedeem();
          this.getVoucherRedeemed();
        } else {
          switch (response.outcome.code) {
            case '0001':
              this.errorMessage = 'Tessera e/o operatore errati. Verificare i dati inseriti';
              break;
            case '0002':
              this.errorMessage = 'Questo voucher non esiste. Verificare i dati inseriti';
              break;
            case '0028':
              this.errorMessage = 'Questo voucher risulta già convertito';
              break;
            case '0029':
              this.errorMessage = 'Questo voucher risulta non ancora richiesto';
              break;
            case '0030':
              this.errorMessage = 'Questo voucher risulta già usato';
              break;
            default:
              this.errorMessage = 'Qualcosa è andato storto';
              break;
          }
          if (showError) {
            swal2('Attenzione', this.errorMessage, 'warning');
          }
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
        swal2('Attenzione', this.errorMessage, 'warning');
        this.spinner.hide()
      }
    );
  }

  getVoucherTransaction(idVoucher) {
    this.transactions = new Array();

    this.spinner.show();

    this.atbService.getListFilter(this.voucherPath + '/' + this.transactionsPath + '/' + idVoucher).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.transactions = response.results
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.spinner.hide()
      }
    );
  }

  openModal(template: TemplateRef<any>, idVoucher) {
    this.getVoucherTransaction(idVoucher);
    this.modalRef = this.modalService.show(template);
  }
  
  close() {
    this.modalRef.hide();
  }

  formatDate(obj) {
    return moment(obj).toISOString();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/views/voucher/voucher-redeem/voucher-redeem.component.ts